import service from '@/api/service/service';
import qs from "qs";

// 获取保存文档列表
export function getDocumentList(params = {}) {
    return service({
        url: '/api/credential/credential_list.json',
        method: 'GET',
        params,
    })
}

export function findDocunmentDetails(uuid) {
    return service({
        url: '/api/credential/view_credential.json',
        method: 'GET',
        params: {
            credential_uuid: uuid
        }
    })
}
// 添加教练员文件存档 输入身份证号 返回姓名 手机号字段
export function getUserInfo(id_number) {
  return service({
    url: '/api/credential/get_user_info.json',
    method: 'GET',
    params: {
      id_number: id_number
    }
  })
}
// 删除文件存档
export function deleteCredential(data = {}) {
  return service({
    url: '/api/credential/delete_credential.json',
    method: 'post',
    data:qs.stringify(data)
  })
}

//添加文件存档
export function createCredential(data = {}) {
  return service({
    url: '/api/credential/create_credential.json',
    method: 'post',
    data:qs.stringify(data)
  })
}
